module.exports = __webpack_public_path__ + "assets/img/4.95059144.gif";